import Timeline from '@/pages/Timeline'

export default {
    path: '/timeline',
    name: 'Timeline',
    component: Timeline
}


// WEBPACK FOOTER //
// ./src/router/timeline.js